<template>
  <div class="text-grey-300 text-15">
    <UserBadge
      :first-name="user.firstName"
      :last-name="user.lastName"
      :color="user.color"
      class="text-app-color"
    />
  </div>
</template>

<script>
import { defineComponent } from 'vue'

export default defineComponent({
  props: {
    user: Object
  }
})
</script>
